"use strict";
// ============================================================================
// FIRELIGHT E-APPLICATION TYPES
// ============================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIRELIGHT_JURISDICTION_MAP = void 0;
/**
 * Firelight state jurisdiction TC codes.
 * Maps US state abbreviations to Firelight's internal TC code integer.
 * Source: FirelightStateTcCodes.cs
 */
exports.FIRELIGHT_JURISDICTION_MAP = {
    AL: 1,
    AK: 2,
    AZ: 4,
    AR: 5,
    CA: 6,
    CO: 7,
    CT: 8,
    DE: 9,
    DC: 10,
    FL: 12,
    GA: 13,
    GU: 14,
    HI: 15,
    ID: 16,
    IL: 17,
    IN: 18,
    IA: 19,
    KS: 20,
    KY: 21,
    LA: 22,
    ME: 23,
    MD: 25,
    MA: 26,
    MI: 27,
    MN: 28,
    MS: 29,
    MO: 30,
    MT: 31,
    NE: 32,
    NV: 33,
    NH: 34,
    NJ: 35,
    NM: 36,
    NY: 37,
    NC: 38,
    ND: 39,
    OH: 41,
    OK: 42,
    OR: 43,
    PA: 45,
    PR: 46,
    RI: 47,
    SC: 48,
    SD: 49,
    TN: 50,
    TX: 51,
    UT: 52,
    VT: 53,
    VI: 54,
    VA: 55,
    WA: 56,
    WV: 57,
    WI: 58,
    WY: 59,
};
//# sourceMappingURL=firelight.js.map